define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ShiftStatusView = require("manager-views/ShiftStatusView");

    var ShiftStatusController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ShiftStatusController = Marionette.Controller.extend({
            initialize: function() {
                this._initialize();
            },
            getView: function() {
                return this._getView();
            },
            show: function(options) {
                return this._show(options);
            },

            _initialize: function() {
                this.channel = LEManager.media.channel(LE.mediaCodes.manager.channels.SHIFT_STATUS);
                this._bindEvents();
            },
            _bindEvents: function() {
                this.listenTo(this.channel.vent, "ShiftStatusView:cancel", this._onCancel);
                this.listenTo(this.channel.vent, "ShiftStatusView:save", this._onSave);
                this.listenTo(this.channel.vent, "ShiftStatusView:goToVisitors", this._onLinkToVisitorsClick);

                this.listenTo(this.channel.vent, "ShiftStatusView:change:shiftStatusMethod", this._onShiftStatusMethodChange);
                this.listenTo(this.channel.vent, "ShiftStatusView:change:manualConfiguration", this._onShiftStatusManualConfigurationChange);
                this.listenTo(this.channel.vent, "ShiftStatusView:open:scheduleGallery", this._onShiftStatusScheduleOpenGalleryClick);
                this.listenTo(this.channel.vent, "ShiftStatusView:open:specialOccasionGallery", this._onShiftStatusSpecialOccasionOpenGalleryClick);

                LEManager.channel.comply(LE.mediaCodes.global.commands.schedule.workingHoursSite, this._onShiftStatusScheduleEdit, this);
                LEManager.channel.comply(LE.mediaCodes.global.commands.specialOccasion.workingHoursSite, this._onShiftStatusSpecialOccasionEdit, this);
            },

            _getView: function() {
                this._initPageComponent();
                return this.pageView;
            },

            _initPageComponent: function() {
                if (this.pageView) {
                    this.pageView.close();
                }
                this.pageView = new Page({
                    moduleName: LEManager.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Dialog,
                    isPermanent: true,
                    header: {
                        title: LE.translator.translate("LEManager.manager.shift.status.new.view.title"),
                        description: LE.translator.translate("LEManager.manager.shift.status.new.view.description"),
                        knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "shift-scheduler"},
                        badge: LE.translator.translate("LEManager.manager.shift.status.new.view.badge.messaging")
                    }
                });
            },

            _show: function(options) {
                this._setInitialSelection(options);

                var viewOptions = {
                    isManual: this.shiftStatusManualSiteSettingsModel.getValue() === "true",
                    scheduledData: {
                        selectedScheduleModel: this.selectedScheduleModel,
                        selectedSpecialOccasionModel: this.selectedSpecialOccasionModel
                    },
                    manualData: this.shiftStatusManualData
                };
                this.shiftStatusView = new ShiftStatusView(viewOptions);
                this.pageView.setInsideView(this.shiftStatusView);
            },

            _setInitialSelection: function() {
                var currentSiteSettingsModel = LEManager.getModuleDataManager().getSiteSettingsManualShiftStatusModel();
                this.shiftStatusManualSiteSettingsModel = (this.isDataUpdated) ? this.shiftStatusManualSiteSettingsModel : currentSiteSettingsModel.clone();
                this.shiftStatusManualSiteSettingsModel.setRevision(currentSiteSettingsModel.getRevision());

                this.selectedScheduleId = (this.isDataUpdated) ? this.selectedScheduleId : LEManager.getModuleDataManager().getSchedulesCollection().getDefaultId();
                this.selectedScheduleModel = LEManager.getModuleDataManager().getSchedulesCollection().get(this.selectedScheduleId);

                this.selectedSpecialOccasionId = (this.isDataUpdated) ? this.selectedSpecialOccasionId : LEManager.getModuleDataManager().getSpecialOccasionsCollection().getDefaultId();
                this.selectedSpecialOccasionModel = LEManager.getModuleDataManager().getSpecialOccasionsCollection().get(this.selectedSpecialOccasionId);

                this.shiftStatusManualData = (this.isDataUpdated) ? this.shiftStatusManualData : {};
                if (_.isEmpty(this.shiftStatusManualData)) {
                    this.brandProfileErrorsCounter = 0;
                    this._fetchManualBrandProfile();
                }

                this.isDataUpdated = false; // we want to reset the flag to FALSE so when the user will go out of the page it will be FALSE.
            },

            _resetSelection: function() {
                this.shiftStatusManualSiteSettingsModel = null;
                this.selectedScheduleId = null;
                this.selectedSpecialOccasionId = null;
                this.shiftStatusManualData = null;
            },

            _fetchManualBrandProfile: function() {
                try {
                    LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.getBrandProfile, {
                        brandId: LE.sessionManager.getAccountId(),
                        success: _.bind(this._onFetchManualBrandProfileSuccess, this),
                        error: _.bind(this._onFetchManualBrandProfileError, this)
                    });
                }
                catch(e) {
                    this._onFetchManualBrandProfileError();
                }
            },

            _onFetchManualBrandProfileSuccess: function(data) {
                this.shiftStatusManualData = data;
                this._updateViewWithManualData();
            },

            _onFetchManualBrandProfileError: function() {
                this.brandProfileErrorsCounter++;
                if (this.brandProfileErrorsCounter < 5) {
                    // in case webagent throws an error, we are waiting 2s and try again
                    _.delay(_.bind(this._fetchManualBrandProfile, this), 2000);
                }
                else {
                    this._showWebsocketError();
                }
            },

            _onShiftStatusMethodChange: function(isManual) {
                this.shiftStatusManualSiteSettingsModel.setValue(String(isManual));
            },

            _onShiftStatusScheduleOpenGalleryClick: function() {
                var path = "shiftStatus/schedules";
                if (this.selectedScheduleId) {
                    path += "/select/" + this.selectedScheduleId;
                }

                this.isDataUpdated = true;
                LEManager.router.navigate(path);
            },

            _onShiftStatusSpecialOccasionOpenGalleryClick: function() {
                var path = "shiftStatus/specialOccasions";
                if (this.selectedSpecialOccasionId) {
                    path += "/select/" + this.selectedSpecialOccasionId;
                }

                this.isDataUpdated = true;
                LEManager.router.navigate(path);
            },

            _onShiftStatusManualConfigurationChange: function(config) {
                var isOnline = config.isOnline;
                var selectedDate = config.selectedDate;
                var selectedHour = config.selectedHour;

                if (isOnline) {
                    this.shiftStatusManualData.delay = {};
                }
                else {
                    var newDate = new Date(selectedDate);
                    var time = selectedHour.split(':');
                    var hour = time[0];
                    var minutes = time[1];
                    newDate.setHours(hour);
                    newDate.setMinutes(minutes);
                    this.shiftStatusManualData.delay.tillWhen = newDate.getTime();
                    this.shiftStatusManualData.delay.type = "NIGHT";
                }

                this.shiftStatusManualData.dateJoined = this.shiftStatusManualData.lastUpdated;
                this._updateViewWithManualData();
            },

            _updateViewWithManualData: function() {
                if (this.shiftStatusView) {
                    this.shiftStatusView.updateManualData(this.shiftStatusManualData);
                }
            },

            _showWebsocketError: function() {
                if (this.shiftStatusView) {
                    this.shiftStatusView.showWebsocketError();
                }
            },

            _onShiftStatusScheduleEdit: function(options) {
                this.selectedScheduleId = options.selectedItemId;
            },

            _onShiftStatusSpecialOccasionEdit: function(options) {
                this.selectedSpecialOccasionId = options.selectedItemId;
            },

            _onCancel: function() {
                this._navigateBack();
            },

            _onSave: function() {
                this.neededAPICalls = {
                    schedule: (this.selectedScheduleModel && this.selectedScheduleModel.id !== LEManager.getModuleDataManager().getSchedulesCollection().getDefaultId()),
                    specialOccasion: (this.selectedSpecialOccasionModel && this.selectedSpecialOccasionModel.id !== LEManager.getModuleDataManager().getSpecialOccasionsCollection().getDefaultId()),
                    manual: (this.shiftStatusManualSiteSettingsModel.getValue() === "true"),
                    shiftStatusMethod: (this.shiftStatusManualSiteSettingsModel.getValue() !== LEManager.getModuleDataManager().getSiteSettingsManualShiftStatusModel().getValue())
                };

                LEManager.showLoader();
                if (this.neededAPICalls.manual) {
                    this._saveManualData();
                }
                else {
                    this._saveScheduleEntity();
                }
            },

            _saveManualData: function() {
                var data = _.cloneDeep(this.shiftStatusManualData);
                data.success = _.bind(this._onSaveManualDataSuccess, this);
                data.error = _.bind(this._onSaveManualDataError, this);
                LE.crossModule("webagent", LE.media.actions.command, LE.mediaCodes.webAgent.commands.setBrandProfile, data);
            },
            _onSaveManualDataSuccess: function() {
                this._saveShiftStatusMethod();
            },
            _onSaveManualDataError: function() {
                this._onSaveError();
            },

            _saveScheduleEntity: function() {
                if (this.neededAPICalls.schedule) {
                    var selectedScheduleModel = this.selectedScheduleModel.clone();
                    selectedScheduleModel.setRevision(this.selectedScheduleModel.getRevision());
                    selectedScheduleModel.setIsDefault(true);
                    selectedScheduleModel.save(null, {
                        success: _.bind(this._onSaveScheduleSuccess, this),
                        error: _.bind(this._onSaveScheduleError, this)
                    });
                }
                else {
                    this._saveSpecialOccasionEntity();
                }
            },
            _onSaveScheduleSuccess: function(model, response, options) {
                LEManager.getModuleDataManager().updateCollection(model);
                this._saveSpecialOccasionEntity();
            },
            _onSaveScheduleError: function(model, response, options) {
                this._onSaveError();
            },

            _saveSpecialOccasionEntity: function() {
                if (this.neededAPICalls.specialOccasion) {
                    var selectedSpecialOccasionModel = this.selectedSpecialOccasionModel.clone();
                    selectedSpecialOccasionModel.setRevision(this.selectedSpecialOccasionModel.getRevision());
                    selectedSpecialOccasionModel.setIsDefault(true);
                    selectedSpecialOccasionModel.save(null, {
                        success: _.bind(this._onSaveSpecialOccasionSuccess, this),
                        error: _.bind(this._onSaveSpecialOccasionError, this)
                    });
                }
                else {
                    this._saveShiftStatusMethod();
                }
            },
            _onSaveSpecialOccasionSuccess: function(model, response, options) {
                LEManager.getModuleDataManager().updateCollection(model);
                this._saveShiftStatusMethod();
            },
            _onSaveSpecialOccasionError: function(model, response, options) {
                // if it's already "scheduled" and we had to save both schedule and special-occasion and the schedule succeed but the SO is not.
                if (this.neededAPICalls.schedule && !this.neededAPICalls.shiftStatusMethod) {
                    this._onSavePartialSuccess();
                }
                else {
                    this._onSaveError();
                }
            },

            _saveShiftStatusMethod: function() {
                // if status method was changed we need to save it as well, if not - continue with the flow
                if (this.neededAPICalls.shiftStatusMethod) {
                    this.shiftStatusManualSiteSettingsModel.save(null, {
                        success: _.bind(this._onSaveSuccess, this),
                        error: _.bind(this._onSaveError, this)
                    });
                }
                else {
                    this._onSaveSuccess();
                }
            },

            _onSaveSuccess: function() {
                LEManager.closeLoader();
                this._showSuccessMessage();
                this._navigateBack();
            },

            _onSaveError: function() {
                LEManager.closeLoader();
                this._showErrorMessage();
            },

            _onSavePartialSuccess: function() {
                LEManager.closeLoader();
                this._showPartialSuccessMessage();
                this._navigateBack();
            },

            _showSuccessMessage: function() {
                LEManager.notifier.showSuccess(LE.translator.translate("LEManager.manager.shift.status.save.success"));
            },

            _showErrorMessage: function() {
                LEManager.notifier.showError(LE.translator.translate("LEManager.manager.shift.status.save.error"));
            },

            _showPartialSuccessMessage: function() {
                LEManager.notifier.showWarning(LE.translator.translate("LEManager.manager.shift.status.save.partial"));
            },

            _onLinkToVisitorsClick: function() {
                LE.crossModule("webagent", LE.mediaCodes.webAgent.redirects.webagent);
            },

            _navigateBack: function () {
                this._resetSelection();
                LEManager.router.navigateBack();
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return  ShiftStatusController;
});

